import { onBeforeUnmount, onMounted, ref } from 'vue'

// Shared across the shell and pages; only collapses to the rail, never hides it.
const collapsed = ref(false)

export function useSidebar() {
  return { collapsed, toggle: () => (collapsed.value = !collapsed.value) }
}

/** Collapses the sidebar while the calling page is mounted and restores it on leave. */
export function useCollapsedSidebar(): void {
  let previous = false
  onMounted(() => {
    previous = collapsed.value
    collapsed.value = true
  })
  onBeforeUnmount(() => {
    collapsed.value = previous
  })
}
